import { useDisclosure } from '@mantine/hooks';

export function usePlaceInformationPageModals() {
  const [
    addEVSEAndConnectorsModalOpened,
    {
      open: openAddEVSEAndConnectorsModal,
      close: closeAddEVSEAndConnectorsModal,
    },
  ] = useDisclosure(false);

  const [
    updateEVSEAndConnectorsModalOpened,
    {
      open: openUpdateEVSEAndConnectorsModal,
      close: closeUpdateEVSEAndConnectorsModal,
    },
  ] = useDisclosure(false);

  const [
    addChargingConnectorModalOpened,
    {
      open: openAddChargingConnectorModal,
      close: closeAddChargingConnectorModal,
    },
  ] = useDisclosure(false);

  const [
    updatePlaceMetadataModalOpened,
    {
      open: openUpdatePlaceMetadataModal,
      close: closeUpdatePlaceMetadataModal,
    },
  ] = useDisclosure(false);

  const [
    addChargingServiceModalOpened,
    { open: openAddChargingServiceModal, close: closeAddChargingServiceModal },
  ] = useDisclosure(false);

  const [
    addParkingServiceModalOpened,
    { open: openAddParkingServiceModal, close: closeAddParkingServiceModal },
  ] = useDisclosure(false);

  const [
    addFuelingServiceModalOpened,
    { open: openAddFuelingServiceModal, close: closeAddFuelingServiceModal },
  ] = useDisclosure(false);

  const [
    updateParkingParkingInfoModalOpened,
    {
      open: openUpdateParkingParkingInfoModal,
      close: closeUpdateParkingParkingInfoModal,
    },
  ] = useDisclosure(false);

  const [
    parkingRateOverviewModalOpened,
    {
      open: openParkingRateOverviewModalDisc,
      close: closeParkingRateOverviewModal,
    },
  ] = useDisclosure(false);

  const [
    updateParkingHeaderInfoModalOpened,
    {
      open: openUpdateParkingHeaderInfoModal,
      close: closeUpdateParkingHeaderInfoModal,
    },
  ] = useDisclosure(false);

  const [
    updateFuelingHeaderInfoModalOpened,
    {
      open: openUpdateFuelingHeaderInfoModal,
      close: closeUpdateFuelingHeaderInfoModal,
    },
  ] = useDisclosure(false);

  const [
    updateChargingHeaderInfoModalOpened,
    {
      open: openUpdateChargingHeaderInfoModal,
      close: closeUpdateChargingHeaderInfoModal,
    },
  ] = useDisclosure(false);

  const [
    updateFuelingFuelingInfoModalOpened,
    {
      open: openUpdateFuelingFuelingInfoModal,
      close: closeUpdateFuelingFuelingInfoModal,
    },
  ] = useDisclosure(false);

  const [
    addMaintenanceServiceModalOpened,
    {
      open: openAddMaintenanceServiceModal,
      close: closeAddMaintenanceServiceModal,
    },
  ] = useDisclosure(false);

  const [
    addInspectionServiceModalOpened,
    {
      open: openAddInspectionServiceModal,
      close: closeAddInspectionServiceModal,
    },
  ] = useDisclosure(false);

  const [
    updateMaintenanceHeaderInfoModalOpened,
    {
      open: openUpdateMaintenanceHeaderInfoModal,
      close: closeUpdateMaintenanceHeaderInfoModal,
    },
  ] = useDisclosure(false);

  const [
    updateInspectionHeaderInfoModalOpened,
    {
      open: openUpdateInspectionHeaderInfoModal,
      close: closeUpdateInspectionHeaderInfoModal,
    },
  ] = useDisclosure(false);

  return {
    addEVSEAndConnectorsModalOpened,
    openAddEVSEAndConnectorsModal,
    closeAddEVSEAndConnectorsModal,
    updateEVSEAndConnectorsModalOpened,
    openUpdateEVSEAndConnectorsModal,
    closeUpdateEVSEAndConnectorsModal,
    addChargingConnectorModalOpened,
    openAddChargingConnectorModal,
    closeAddChargingConnectorModal,
    updatePlaceMetadataModalOpened,
    openUpdatePlaceMetadataModal,
    closeUpdatePlaceMetadataModal,
    addChargingServiceModalOpened,
    openAddChargingServiceModal,
    closeAddChargingServiceModal,
    addParkingServiceModalOpened,
    openAddParkingServiceModal,
    closeAddParkingServiceModal,
    addFuelingServiceModalOpened,
    openAddFuelingServiceModal,
    closeAddFuelingServiceModal,
    updateParkingParkingInfoModalOpened,
    openUpdateParkingParkingInfoModal,
    closeUpdateParkingParkingInfoModal,
    parkingRateOverviewModalOpened,
    openParkingRateOverviewModalDisc,
    closeParkingRateOverviewModal,
    updateParkingHeaderInfoModalOpened,
    openUpdateParkingHeaderInfoModal,
    closeUpdateParkingHeaderInfoModal,
    updateFuelingHeaderInfoModalOpened,
    openUpdateFuelingHeaderInfoModal,
    closeUpdateFuelingHeaderInfoModal,
    updateChargingHeaderInfoModalOpened,
    openUpdateChargingHeaderInfoModal,
    closeUpdateChargingHeaderInfoModal,
    updateFuelingFuelingInfoModalOpened,
    openUpdateFuelingFuelingInfoModal,
    closeUpdateFuelingFuelingInfoModal,
    addMaintenanceServiceModalOpened,
    openAddMaintenanceServiceModal,
    closeAddMaintenanceServiceModal,
    addInspectionServiceModalOpened,
    openAddInspectionServiceModal,
    closeAddInspectionServiceModal,
    updateMaintenanceHeaderInfoModalOpened,
    openUpdateMaintenanceHeaderInfoModal,
    closeUpdateMaintenanceHeaderInfoModal,
    updateInspectionHeaderInfoModalOpened,
    openUpdateInspectionHeaderInfoModal,
    closeUpdateInspectionHeaderInfoModal,
  };
}
